import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EPriority } from 'src/app/project/modules/points/priorities';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterPriority,
  TAdvancedFilterSingle,
  TFilterPriorityOptions,
} from '../../../../models/advanced-filter.model';
import { getAdvancedPriorityValues } from './advanced-filter-priority-utils';
import { priorityOperatorOptions } from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-priority',
  templateUrl: './advanced-filter-priority.component.html',
  styleUrls: ['./advanced-filter-priority.component.scss'],
  standalone: false,
})
export class AdvancedFilterPriorityComponent {
  @Input() ppFilter: TAdvancedFilterSingle; // If we do TAdvancedFilterPriority it will throw ESLINT error in HTML
  @Input() ppIndex: number;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: EPriority[];
  option: TFilterPriorityOptions;
  filter: TAdvancedFilterPriority;

  ADVANCED_FILTER_PRIORITY_OPTIONS = priorityOperatorOptions;
  ADVANCED_FILTER_PRIORITY_VALUES = getAdvancedPriorityValues();
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterPriority;

    this.value = this.filter.value ? this.filter.value : [];
    this.option = this.filter.option;

    this.ADVANCED_FILTER_PRIORITY_VALUES.forEach((priority) => {
      priority.selected = this.filter.value?.includes(priority.value);
    });
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    const value = newCondition.value as TFilterPriorityOptions;
    if (
      (value === EAdvancedFilterOptions.IS || value === EAdvancedFilterOptions.IS_NOT) &&
      this.filter.value?.length
    ) {
      this.filter.value.length = 1;
      this.value = this.filter.value;

      this.ADVANCED_FILTER_PRIORITY_VALUES.forEach((priority) => {
        priority.selected = this.filter.value?.includes(priority.value);
      });
    }

    this.ppFilter.operator = newCondition.operator;

    this.ppFilter.option = value;
    this.option = value;
    this.applyChanges();
  }

  changeFieldValue(newValue: TSelectOption): void {
    const value = newValue.value as EPriority;
    if (this.filter.value?.length) {
      this.ppFilter.value[0] = value;
    } else {
      this.ppFilter.value = [value];
    }

    this.applyChanges();
  }

  changeFieldValueMultiple(): void {
    this.filter.value = this.ADVANCED_FILTER_PRIORITY_VALUES.filter((value) => value.selected).map(
      (value) => value.value,
    ) as EPriority[];

    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }
}
